import {ACTIONS} from './constants';

export const setActiveResponseId = (activeResponseId) => {
    return {
        type: ACTIONS.SET_ACTIVE_RESPONSE_ID,
        activeResponseId,
    };
};
